module.exports = new __parcel__URL__("bee.1d8bfe50.svg").toString();